import React, { useContext, useState, useEffect } from 'react';
import progressBarBackgroundColor from 'common/ProgressBarBackgroundColor';

import { CircularProgressIndicatorContext } from './CircularProgressIndicatorDeterminate';
import Styled, { getStrokeWidth } from './styles';

export interface CircularProgressIndicatorProgressCircleProps extends React.ComponentPropsWithRef<'div'> {
  /** How much progress is complete. The progress value has to be between 0 and 100. Pass rounded progress value */
  progress: number;
  /** If true, disable all motion animation for this component.  This property will override any global disableAnimation setting. */
  disableAnimation?: boolean;
  /** To override the theme please refer to the "Readme" tab to learn more. */
  theme?: any;
}

const CircularProgressIndicatorProgressCircle = (props: CircularProgressIndicatorProgressCircleProps) => {
  const {
    progress,
    disableAnimation,
    theme
  } = props;

  const circularIndicatorContext = useContext(CircularProgressIndicatorContext);
  const strokeWidth = getStrokeWidth(circularIndicatorContext.circleSize);
  const circleRadius = (circularIndicatorContext.circleSize - strokeWidth) / 2;
  const centerOfTheCircle = circularIndicatorContext.circleSize / 2;
  const circleCircumference = 2 * Math.PI * circleRadius;

  const [offset, setOffset] = useState(circleCircumference);
  const strokeProgress = progress > 0 ? progress : offset;

  useEffect(() => {
    const progressOffset = ((100 - progress) / 100) * circleCircumference;
    setOffset(progressOffset);
  }, [setOffset, circleCircumference, progress, offset]);

  return (
    <Styled.Circle2
      cx={centerOfTheCircle}
      cy={centerOfTheCircle}
      r={circleRadius}
      strokeWidth={strokeWidth}
      strokeDasharray={circleCircumference}
      stroke={`rgb(${progressBarBackgroundColor(strokeProgress, theme)})`}
      strokeDashoffset={offset}
      $disableAnimation={disableAnimation}
    />
  );
};

CircularProgressIndicatorProgressCircle.defaultProps = {
  disableAnimation: undefined,
  theme: {},
};

CircularProgressIndicatorProgressCircle.displayName = 'CircularProgressIndicatorProgressCircle';

export default CircularProgressIndicatorProgressCircle;